/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateAuthenticationConfigurationRequest } from '../../models/update-authentication-configuration-request';

export interface UpdateAuthenticationConfiguration$Params {
  organizationId: string;
  
    /**
     * Authentication configuration to be updated.
     */
    body: UpdateAuthenticationConfigurationRequest
}

export function updateAuthenticationConfiguration(http: HttpClient, rootUrl: string, params: UpdateAuthenticationConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateAuthenticationConfiguration.PATH, 'put');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateAuthenticationConfiguration.PATH = '/v1/organizations/{organizationId}/configuration/authentication';
